import actions from '../../actionTypes';

export default siteId => {
  return {
    type: actions.GET_GROUPS,
    siteId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/groups/actions/getGroups.js